<template>
  <div :class="$style.gridDatePicker">
    <input ref="input" v-model="value" type="date" />
  </div>
</template>

<script>
import Vue from "vue";
import { encodeDate } from "@/utils/common";

export default Vue.extend({
  data() {
    return {
      value: null,
    };
  },

  methods: {
    getValue() {
      return this.value ? new Date(this.value) : null;
    },

    afterGuiAttached() {
      this.$refs.input.focus();
    },
  },

  created() {
    if (
      this.params.keyPress === 46 ||
      this.params.keyPress === 8 ||
      !this.params.value
    ) {
      this.value = null;
    } else {
      this.value = encodeDate(this.params.value);
    }
  },
});
</script>

<style lang="scss" module>
.grid-date-picker {
  width: 100%;
  height: 100%;

  input {
    width: 100%;
    height: 100%;
  }
}
</style>
